import React from "react";
import { Link } from "react-router-dom";
import { useCollection } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

const Projects = () => {
  const projects = useCollection("projects") || [];

  return (
    <div className="px-6 md:px-10 max-w-[1100px] mx-auto">
      <SEO
        title="Projects"
        description="Long-term personal projects by photographer Alice Lisi — Space of Exception, 7 × 7 = 49, Zoo Island, Dal Primo Giorno, Ali Sporche, Neverland."
        path="/projects"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-16 pb-8">
        {projects.map((p) => (
          <Link to={`/projects/${p.id}`} key={p.id} className="tile group">
            <div className="aspect-square bg-[color:var(--paper-2)] overflow-hidden">
              {p.cover ? (
                <img
                  src={resolveImg(p.cover)}
                  alt={p.title}
                  loading="lazy"
                  decoding="async"
                  className="tile-img w-full h-full object-cover"
                />
              ) : null}
            </div>
            <div className="mt-4">
              <p className="font-serif italic text-xl leading-tight">
                {p.title}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Projects;
